<ng-container *ngIf="isDisplayCardSelecting">
  <h3 class="c-heading-3" [innerHTML]="'label.alwaysInformation' | staticMsg"></h3>
  <div class="p-card-to-use js-card-to-use">
    <div class="p-card-to-use__change" [ngClass]="{ 'is-open': isSelectedCardSP && isSp }">
      <div class="p-card-to-use__change-item">
        <div class="p-card-to-use__change-title" [ngSwitch]="selectedCard">
          <ng-container *ngSwitchCase="newCard">
            <span class="p-card-to-use__change-title-label" [innerHTML]="'label.newCreditCard' | staticMsg"></span>
            <span class="u-visually-hidden" [innerHTML]="'label.newCreditCard' | staticMsg"></span>
          </ng-container>
          <ng-container *ngIf="amc.generalCreditCardName1">
            <ng-container *ngSwitchCase="paymentCard1">
              <span class="p-card-to-use__change-title-label" [innerHTML]="'label.basicCard1' | staticMsg"></span>
              <span class="u-visually-hidden" [innerHTML]="'label.basicCard1' | staticMsg"></span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="amc.generalCreditCardName2">
            <ng-container *ngSwitchCase="paymentCard2">
              <span class="p-card-to-use__change-title-label" [innerHTML]="'label.basicCard2' | staticMsg"></span>
              <span class="u-visually-hidden" [innerHTML]="'label.basicCard2' | staticMsg"></span>
            </ng-container>
          </ng-container>
        </div>
        <div class="p-card-to-use__change-btn">
          <asw-button
            type="tertiary"
            size="xs"
            (click$)="onChangeSelectedCardSp()"
            [label]="'label.detailsLinkToChangeCard' | staticMsg"
          ></asw-button>
        </div>
      </div>
    </div>
    <div class="p-card-to-use__menu" [ngClass]="{ 'is-hide': isSelectedCardSP && isSp }">
      <div
        class="p-card-to-use__menu-item"
        [ngClass]="{
          'p-card-to-use__menu-item--selected': selectedCard === newCard
        }"
      >
        <div class="p-card-to-use__menu-title">
          <div class="p-card-to-use__menu-title-label" [innerHTML]="'label.newCreditCard' | staticMsg"></div>
        </div>
        <div class="p-card-to-use__menu-btn">
          <div *ngIf="selectedCard === 'newCard'" class="p-card-to-use__menu-btn-mark">
            <img
              src="assets/images/icon_check_primary_20.svg"
              width="20"
              height="20"
              [attr.alt]="'labbel.cardSelected' | staticMsg"
            />
          </div>
          <button
            id="card-to-use-menu-button1"
            class="p-card-to-use__menu-btn-select c-btn-primary c-btn-primary--xs"
            aria-label="Select New Credit Card"
            (click)="onClickNewCard()"
          >
            <span class="c-btn-primary__text" [innerHTML]="'label.cardSelect' | staticMsg"></span>
          </button>
        </div>
      </div>
      <div
        class="p-card-to-use__menu-item"
        [ngClass]="{
          'p-card-to-use__menu-item--selected': selectedCard === paymentCard1
        }"
        *ngIf="amc.generalCreditCardName1"
      >
        <div class="p-card-to-use__menu-title">
          <div class="p-card-to-use__menu-title-label" [innerHTML]="'label.basicCard1' | staticMsg"></div>
          <div class="p-card-to-use__menu-title-lead" [innerHTML]="'label.regulerCardInfomation' | staticMsg"></div>
        </div>
        <div class="p-card-to-use__menu-btn">
          <div *ngIf="selectedCard === paymentCard1" class="p-card-to-use__menu-btn-mark">
            <img
              src="assets/images/icon_check_primary_20.svg"
              width="20"
              height="20"
              [attr.alt]="'labbel.cardSelected' | staticMsg"
            />
          </div>
          <button
            id="select-corporate-card1"
            class="p-card-to-use__menu-btn-select c-btn-primary c-btn-primary--xs"
            aria-label="selectCreditCardName1"
            (click)="onClickPaymentCard1()"
          >
            <span class="c-btn-primary__text" [innerHTML]="'label.cardSelect' | staticMsg"> </span>
          </button>
        </div>
      </div>
      <div
        [ngClass]="{
          'p-card-to-use__menu-item': true,
          'p-card-to-use__menu-item--selected': selectedCard === paymentCard2
        }"
        *ngIf="amc.generalCreditCardName2"
      >
        <div class="p-card-to-use__menu-title">
          <div class="p-card-to-use__menu-title-label" [innerHTML]="'label.basicCard2' | staticMsg"></div>
          <div class="p-card-to-use__menu-title-lead" [innerHTML]="'label.regulerCardInfomation' | staticMsg"></div>
        </div>
        <div class="p-card-to-use__menu-btn">
          <div *ngIf="selectedCard === paymentCard2" class="p-card-to-use__menu-btn-mark">
            <img
              src="assets/images/icon_check_primary_20.svg"
              width="20"
              height="20"
              [attr.alt]="'labbel.cardSelected' | staticMsg"
            />
          </div>
          <button
            id="card-to-use-menu-button3"
            class="p-card-to-use__menu-btn-select c-btn-primary c-btn-primary--xs"
            aria-label="selectCreditCardName2"
            (click)="onClickPaymentCard2()"
          >
            <span class="c-btn-primary__text" [innerHTML]="'label.cardSelect' | staticMsg"> </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="p-form-layout01" [formGroup]="paymentInputFG!">
  <div class="p-form-layout01__item">
    <h3
      class="p-form-layout01__item-title p-form-layout01__item-title--l"
      [innerHTML]="titleCreditCard | staticMsg"
    ></h3>
    <div class="p-input-block01">
      <div class="p-input-block01__item">
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <div class="p-input-block01__row-head u-display-block-pc">
            <span class="p-input-block01__row-title" [innerHTML]="'message.applicableCreditCards' | staticMsg"></span>
          </div>
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item">
              <ul class="c-cardlogo-list">
                <li class="c-cardlogo-list__item" *ngFor="let item of cardBrandImageList">
                  <img src="assets/images/{{ item.src }}" width="36" height="26" alt="{{ item.alt }}" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <div class="p-input-block01__row-head u-display-block-pc">
            <span class="p-input-block01__row-title" [innerHTML]="'label.creditcardArea' | staticMsg"> </span>
          </div>
          <div class="p-input-block01__row-body">
            <div *ngIf="isDisplayUatpCheckbox" class="p-input-block01__row-body-item">
              <asw-checkbox
                formControlName="uATPCardChecked"
                label="{{ 'message.useUatpCard' | staticMsg }}"
                (change$)="onChangeUatpCardSelection()"
              >
              </asw-checkbox>
            </div>
            <div class="p-input-block01__row-body-item p-input-block01__row-body-item--mt16">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <ng-container *ngIf="isDisplayCardNumberAsTextBox === true; else isDisplayCardNumberAsLabel">
                  <asw-input
                    id="service-request-payment-input-card-info-input-1"
                    label="{{ 'label.creditCardNumber' | staticMsg }}"
                    formControlName="cardNumber"
                    maxlength="16"
                    required
                    placeholder="{{ 'placeholder.creditCardNumber' | staticMsg }}"
                  ></asw-input>
                </ng-container>
                <ng-template #isDisplayCardNumberAsLabel>
                      <label class="c-form-element-input__wrap">
                        <span class="c-form-element-input__label">
                          <span
                            class="c-form-element-input__label-text"
                            [innerHTML]="'reader.creditCardNumber' | staticMsg"
                          ></span>
                        </span>
                        <span class="c-form-element-input__input">
                          <span class="c-form-element-input__input-item" [innerHTML]="cardNumberAsLabel"></span>
                        </span>
                      </label>
                </ng-template>
              </div>
            </div>
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-head">
                <span class="p-input-block01__row-title" [innerHTML]="'label.expirationDate' | staticMsg"> </span>
                <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"> </span>
              </div>
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-select-date-ym
                  formControlName="expiryDate"
                  [displayType]="'my'"
                  [yearRange]="this.yearRange"
                ></asw-select-date-ym>
              </div>
            </div>
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-input
                  id="service-request-payment-input-card-info-input-4"
                  label="{{ 'label.securityCode' | staticMsg }}"
                  formControlName="cvv"
                  required
                  maxlength="4"
                  placeholder="{{ 'placeholder.securityCode' | staticMsg }}"
                ></asw-input>
              </div>
            </div>
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <span class="u-visually-hidden" [innerHTML]="'reader.cardholderName' | staticMsg"></span>
                <asw-input
                  id="service-request-payment-input-card-info-input-5"
                  label="{{ 'label.cardholderName' | staticMsg }}"
                  formControlName="holderName"
                  placeholder="{{ 'placeholder.cardholderName' | staticMsg }}"
                  required
                  maxlength="40"
                ></asw-input>
              </div>
            </div>
            <div
              *ngIf="isShownRegistrationUpdateCheckbox"
              class="p-input-block01__row-body-item p-input-block01__row-body-item--mt16"
            >
              <asw-checkbox
                id="service-request-payment-input-card-info-checkbox-2"
                label="{{ 'checkbox.registerRegularPaymentMethod' | staticMsg }}"
                formControlName="saveAsBasicReservationInformation"
              ></asw-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="p-form-layout01__item">
    <h3 class="p-form-layout01__item-title p-form-layout01__item-title--l">
      {{ 'heading.cardholderImformation' | staticMsg }}
    </h3>
    <div class="p-input-block01">
      <div class="p-input-block01__item">
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <div class="p-input-block01__row-head">
            <span class="p-input-block01__row-title" [innerHTML]="'label.eMail.passengerInput' | staticMsg"></span>
            <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"> </span>
          </div>
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <span class="u-visually-hidden" [innerHTML]="'reader.eMailAddress' | staticMsg"></span>
                <asw-input
                  id="payment-card-holder-info-email"
                  label="{{ 'label.eMailAddress.passengerInput' | staticMsg }}"
                  maxlength="50"
                  formControlName="cardHolderEmail"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  (change$)="emailChange()"
                ></asw-input>
                <div></div>
              </div>
            </div>

            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <span class="u-visually-hidden" [innerHTML]="'reader.cardHolderEMailAddress' | staticMsg"> </span>
                <asw-input
                  id="payment-card-holder-info-confirm-email"
                  label="{{ 'label.confirmMailAddress' | staticMsg }}"
                  maxlength="50"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  formControlName="cardHolderConfirmEmail"
                  [disablePaste]="true"
                  (change$)="emailChange()"
                ></asw-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-input-block01__item">
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <div class="p-input-block01__row-head">
            <span class="p-input-block01__row-title" [innerHTML]="'label.telNumber' | staticMsg"> </span>
            <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"> </span>
          </div>
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <span class="u-visually-hidden" [innerHTML]="'reader.countryCode' | staticMsg"></span>
                <asw-select
                  id="payment-credit-country-select"
                  label="{{ 'label.countryCode' | staticMsg }}"
                  formControlName="cardHolderPhoneCountry"
                  (change$)="onChangeCountry()"
                >
                  <option
                    *ngFor="let phoneCountryInfo of phoneNumberCountryList"
                    [value]="phoneCountryInfo.country2LetterCode"
                    [innerHTML]="phoneCountryInfo.countryName"
                  ></option>
                </asw-select>
              </div>
            </div>
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-head">
                <p
                  id="describe01"
                  class="p-input-block01__row-body-item-text"
                  [innerHTML]="'message.phoneNumberAttention' | staticMsg"
                ></p>
              </div>
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <span class="u-visually-hidden" [innerHTML]="'reader.cardHolderTelNumber' | staticMsg"> </span>
                <asw-input
                  id="payment-credit-telephone"
                  label="{{ 'label.cardHolderTelNumber' | staticMsg }}"
                  placeholder="{{ 'placeholder.phoneNumber.international' | staticMsg }}"
                  [phoneCode]="cardHolderCountryPhoneExtension"
                  displayType="phone"
                  maxlength="16"
                  formControlName="cardHolderPhoneNumber"
                  [conversionType]="'phoneNumber'"
                ></asw-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-form-layout02" *ngIf="isDisplayIssuerReceipt" [formGroup]="paymentInputFG!">
  <div class="p-form-layout02__item">
    <h3 class="p-form-layout02__item-title p-form-layout02__item-title--l">
      {{ 'heading.receipt' | staticMsg }}
    </h3>
    <div class="p-form-layout02__item-body">
      <div class="p-form-layout02__item-body-box p-form-layout02__item-body-box--w325">
        <span class="u-visually-hidden" [innerHTML]="'reader.inputReceiptName' | staticMsg"></span>
        <asw-input
          id="payment-credit-receipt-name"
          label="{{ 'label.receiptName' | staticMsg }}"
          placeholder="{{ 'placeholder.receiptName1' | staticMsg }}"
          formControlName="issuerReceiptEmail"
          maxlength="40"
        ></asw-input>
      </div>
    </div>
  </div>
</div>
